module.exports = __webpack_public_path__ + "static/media/AlbanyAdvertiser-devicecomp-min.f963b8a0.webp";